import { createContext, use } from "react";
import { defined } from "@entrilia/shared/utilities/typeHelper";

interface ContextValue {
  persistedClosedItems: string[];
  addClosedItem: (item: string) => void;
  removeClosedItem: (item: string) => void;
}

export const MainMenuContext = createContext<ContextValue | undefined>(undefined);

export const useMainMenuContext = () =>
  defined(use(MainMenuContext), "Attempted to use MainMenuContext outside of its provider");
